<div class="modal-header">
  <h5 class="modal-title">Recommended for you</h5>
  <button type="button" class="close" aria-label="Close" (click)="hideModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <ng-container *ngIf="upSellItems.length > 0">
    <app-ecom-item-upsell-grid [upSellItems]="upSellItems"></app-ecom-item-upsell-grid>
  </ng-container>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="hideModal()">No, thanks</button>
</div>